import { useState } from "react";
import { delay, when } from "util/support";
import { FormField, type OnboardingDirectorsAndShareholdersProps } from "../types";
import { ShareholderIdentity } from "../entities";

export const useOtherShareholders = ({
    isValid,
    values,
    setFieldValue
}: OnboardingDirectorsAndShareholdersProps) => {
    const [tab, setTab] = useState('1');

    const async = (fn: () => void, timeout = 100) =>
        delay(timeout)
            .finally(fn);

    const addShareholder = () => {
        const { length } = values[FormField.OtherPeople.FieldPrefix];

        setFieldValue(FormField.OtherPeople.FieldPrefix, [
            ...values[FormField.OtherPeople.FieldPrefix],
            new ShareholderIdentity()
        ], true);

        async(() => setTab(String(length + 1)));
    };

    const deleteShareholder = (index: number) => {
        setFieldValue(
            FormField.OtherPeople.FieldPrefix,
            values[FormField.OtherPeople.FieldPrefix]
                .filter((_, i) => !Object.is(i, index)),
            true
        );

        async(() => setTab(Math.max(Number(tab) - 1, 1).toString()));
    };

    const onChangeTab = (activeTab: string) => setTab(activeTab);

    const canAddShareholder = () => when(
        values[FormField.OtherPeople.FieldPrefix].length,
        isValid,
        true
    );

    return {
        tab,
        addShareholder,
        deleteShareholder,
        onChangeTab,
        canAddShareholder
    };
};

export default useOtherShareholders;
